module.exports = __webpack_public_path__ + "img/Bilder_Geschichte_1270x415_01.c7a1201.jpg";